import { staticGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import * as z from "zod/v4";

export const createStaticSegment = {
  name: "createStaticSegment" as const,
  input: z.object({ name: z.string() }),
  output: staticGroupSchema,
};
